/* this file is transformed by vux-loader */
/* eslint-disable */
import _toConsumableArray from "G:/SVN/\u5B9A\u5236\u9879\u76EE/\u534E\u7535\u5F00\u5173/7_\u6E90\u4EE3\u7801/front/smy-vux-cli3-h5-huadian/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _objectSpread from "G:/SVN/\u5B9A\u5236\u9879\u76EE/\u534E\u7535\u5F00\u5173/7_\u6E90\u4EE3\u7801/front/smy-vux-cli3-h5-huadian/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.array.concat.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Group from "vux/src/components/group/index.vue";
import Cell from "vux/src/components/cell/index.vue";
import PopupPicker from "vux/src/components/popup-picker/index.vue";
import ViewBox from "vux/src/components/view-box/index.vue";
import Search from "vux/src/components/search/index.vue";
import SinglePicker from '@/components/Base/SinglePicker';
import SelectPicker from '@/components/Common/SelectPicker';
import GeneralServiceContent from './GeneralServiceContent';
import { getHdOrderServiceContent } from '@/api';
export default {
  name: 'ServiceContent',
  props: {
    baseInfo: {
      type: Object
    }
  },
  components: {
    Search: Search,
    ViewBox: ViewBox,
    Group: Group,
    Cell: Cell,
    PopupPicker: PopupPicker,
    SinglePicker: SinglePicker,
    GeneralServiceContent: GeneralServiceContent,
    SelectPicker: SelectPicker
  },
  data: function data() {
    return {
      searchForm: {
        keyword: ''
      },
      isShowPicker: false,
      orderList: [],
      pageIndex: 0,
      pageSize: 10
    };
  },
  activated: function activated() {
    this.loadList(true);
  },
  computed: {},
  methods: {
    loadList: function loadList() {
      var _this = this;

      var reset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var operation = arguments.length > 1 ? arguments[1] : undefined;

      if (reset) {
        this.pageIndex = 0;
        this.$vux.loading.show({
          text: '加载中...'
        });
      }

      return new Promise(function (resolve) {
        var data = _objectSpread(_objectSpread({
          pageIndex: _this.pageIndex,
          pageSize: _this.pageSize
        }, _this.searchForm), {}, {
          fk_t_order_id: _this.baseInfo.fk_t_order_id
        });

        getHdOrderServiceContent(data).then(function (res) {
          // 不重置数据累计
          if (!reset) {
            _this.orderList = Object.freeze([].concat(_toConsumableArray(_this.orderList), _toConsumableArray(res.data.data)));
          } else {
            setTimeout(function () {
              return _this.$vux.loading.hide();
            }, 500);
            _this.orderList = Object.freeze(res.data.data);
          }

          if (operation === 'search') {
            _this.$refs.orderList.scrollToTop();
          }

          resolve(); // 判断是否有新数据

          if (res.data.length >= _this.pageSize) {
            _this.$refs['orderList'] && _this.$refs['orderList'].forceUpdate(true);
          } else {
            _this.$refs['orderList'] && _this.$refs['orderList'].forceUpdate(false);
          }
        });
      });
    },
    onPulldownLoading: function onPulldownLoading() {
      this.loadList(true).then(function () {});
    },
    onPullupLoading: function onPullupLoading() {
      this.pageIndex = this.pageIndex + 1;
      this.loadList().then(function () {});
    }
  }
};